export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen4_in.090f2139.mp4";